import React, { useState, useContext } from 'react';
import { PrimaryButton, SecondaryButton } from '@carvana/showroom-forms';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import ImagePicker from './ImagePicker';
import { ModalContentWrapper } from '../../../ASRCard.styles';
import { ButtonRow } from '../../styles';
import { useRouter, ROUTES } from '../../../providers/router';
import { useCreateAsr } from '../../../providers/create-asr';
import { AsrAnalytics } from '../../../../../constants';

const ASRImageSelector = () => {
  const { goToRoute } = useRouter();
  const { asrIssue, updateAsrIssue, saveAsr } = useCreateAsr();
  const { trackEvent } = useContext(AnalyticsContext);

  const [images, setImages] = useState(Array(2));
  const addImage = (file: File, index: number) => {
    const isReplacing = !!images[index];
    if (isReplacing) {
      trackEvent(AsrAnalytics.COS_CLICKED_REPLACE);
    }
    images[index] = file;
    const selectedImages = [...images];
    updateAsrIssue({ images: selectedImages });
    setImages(selectedImages);
  };

  return (
    <ModalContentWrapper>
      <div>
        <b>Take a close-up photo of the concern.</b>
      </div>
      <div>
        Position your phone about 1 - 2 feet from the concern you are taking a
        picture of.
      </div>
      <ImagePicker testId="close-picture-id" onSelect={x => addImage(x, 0)} />
      <div>
        <b>Take a photo from 4 - 6 feet away</b>
      </div>
      <div>
        Stand 4 - 6 feet away from your car and take a picture of the concern.
      </div>
      <ImagePicker testId="far-picture-id" onSelect={x => addImage(x, 1)} />
      <ButtonRow>
        <SecondaryButton
          onClick={() => {
            trackEvent(AsrAnalytics.COS_CLICKED_BACK);
            goToRoute(ROUTES.COSMETIC_DISCLAIMER);
          }}
        >
          Back
        </SecondaryButton>
        <PrimaryButton
          name="forward-button"
          onClick={() => {
            trackEvent(AsrAnalytics.COS_CLICKED_SUBMIT, { asrIssue });
            saveAsr();
          }}
          disabled={!images[0] || !images[1]}
        >
          Submit
        </PrimaryButton>
      </ButtonRow>
    </ModalContentWrapper>
  );
};

export default ASRImageSelector;
